export const questionsTwo = [
  {
    id: 1,
    question:
      "Which number should fill in the blank: 70,71, 76, __, 81, 86, 70, 91, ",
    answer: "70",
    options: ["70", "71", "80", "96"],
    explanations: [
      "In this series, 5 is added to the previous number; the number 70 is inserted as every third number.",
    ],
  },
  {
    id: 2,
    question:
      "Suresh introduces a man as “He is the son of the woman who is the mother of the husband of my mother”. How is Suresh related to the man? ",
    answer: "Nephew",
    options: ["Uncle", "Son", "Cousin", "Nephew"],
    explanations: [
      "That man is the uncle of Suresh. Hence Suresh is the nephew of that man.",
    ],
  },
  {
    id: 3,
    question: "Which one of them is not correctly matched?",
    answer: "Biology : Botany",
    options: [
      "Phycology : Algae",
      "Ornithology : Bird",
      "Mycology : Fungi",
      "Biology : Botany",
    ],
    explanations: ["In all other pairs, first is the study of the second"],
  },
  {
    id: 4,
    question: "Find the missing number: 3, 3, 9, 8, 4, 4, 16, 15, 5, 5, 25, ?",
    answer: "24",
    options: ["24", "16", "20", "21"],
    explanations: [
      "3 Sq > 9, 9-1 = 8. 4 Sq > 16, 16-1 = 15. Hence 5 Sq > 25, 25-1 = 24.",
    ],
  },
  {
    id: 5,
    question:
      "If in a certain language FASHION is coded as FOIHSAN, how is PROBLEM coded in that code?",
    answer: "PELBORM",
    options: ["PELBROM", "PRBOELM", "PELBORM", "ROBLEMP"],
    explanations: [
      "First and last remain the same and the remaining letters are written in reverse order",
    ],
  },
  {
    id: 6,
    question: "Which word will come last in the dictionary?",
    answer: "Grey",
    options: ["Gram", "Grasp", "Graze", "Grey"],
    explanations: ["Grey will come last in the dictionary."],
  },
  {
    id: 7,
    question:
      "Last digit of the smallest number from the following :  467922, 468910, 461093, 497252",
    answer: "3",
    options: ["3", "0", "2", "6"],
    explanations: ["The smallest number in the series is 461093."],
  },
  {
    id: 8,
    question: "Correct meaning of Proverb : A snake in the grass",
    answer: "Unrecognizable danger",
    options: [
      "Secret or hidden enemy",
      "unforeseen happening",
      "A snake in the grass",
      "None of these",
    ],
    explanations: ["A snake in the grass - A snake in the grass."],
  },
  {
    id: 9,
    question: "By how many degrees a minute hand rotates in 45 minutes?",
    answer: "270°",
    options: ["45°", "90°", "180°", "270°"],
    explanations: ["15 min is 90 Degree. Hence 45 mins is 90x3 = 270 degree."],
  },
  {
    id: 10,
    question: "Correct meaning of Proverb : To talk through one's hat",
    answer: "To talk nonsense",
    options: [
      "To speak fluently",
      "To talk nonsense",
      "To talk wisdom",
      "To speak at random",
    ],
    explanations: ["To talk through one's hat - To talk nonsense"],
  },
  {
    id: 11,
    question: "Gold : Ornament :: Wood : ?",
    answer: "Furniture",
    options: ["Forest", "Furniture", "Saw-dust", "Timber"],
    explanations: ["First is the material used to make second."],
  },
  {
    id: 12,
    question:
      "If in a certain language, COUNSEL is coded as BITIRAK, how is GUIDANCE written in that code?",
    answer: " FOHYZJBB",
    options: ["FOHYZJBB", "EOHYZKBB", "HOHYBJBA", "HOHYBJBA"],
    explanations: [
      "The letters at odd positions are each moved one step backward, while the letters at even positions are respectively moved six, five, four, three, two,... steps backward to obtain the corresponding letters of the",
    ],
  },
  {
    id: 13,
    question: "Which word will come last in the dictionary?",
    answer: "Quote",
    options: ["Quiet", "Quick", "Queue", "Quote"],
    explanations: ["Quote will come last in dictionary."],
  },
  {
    id: 14,
    question: " 1/9 , 1/3 , 1, __, 9, ",
    answer: "3",
    options: ["3", "2/3", "6", "27"],
    explanations: [
      "Every consecutive term is the previous term multiplied by 3",
    ],
  },
  {
    id: 15,
    question: "J14, L16, ? , P20, R22,",
    answer: "N18",
    options: ["S24", "N18", "M18", "T24"],
    explanations: [
      "In this series, the letters progress by 2, and the numbers increase by 2.",
    ],
  },
  {
    id: 16,
    question:
      "If in a certain language, MACHINE is coded as LBB1HOD, which word would be coded as SLTMFNB?",
    answer: "TKULGMC",
    options: ["TMUNGOC", "TMUNGMC", "TKULGMC", "RMSNEOA"],
    explanations: [
      "One letter one step behind and the next letter one step ahead of the corresponding letter in the code word.",
    ],
  },
  {
    id: 17,
    question:
      "The last alphabet of the word which comes last in the dictionary : Worth, Wealth, Wave, Wasp",
    answer: "h",
    options: ["h", "e", "p", "None of these"],
    explanations: ["Worth will come last in the dictionary."],
  },
  {
    id: 18,
    question: "Whale is a mammal because",
    answer: "They give birth",
    options: [
      "It has a pair of lungs",
      "A four-chambered heart",
      "They are huge in size",
      "They give birth",
    ],
    explanations: ["Whale is a mammal because they give birth"],
  },
  {
    id: 19,
    question: "Fill in the blanks : BA_BA_B_CBA_B_C",
    answer: "CCACA",
    options: ["CABBC", "BCABC", "CCACA", "BCABB"],
    explanations: ["The series is bac/bac/bac/bac/bac/bac."],
  },
  {
    id: 20,
    question: "Glucose : Carbohydrate :: Soyabean : ?",
    answer: "Proteins",
    options: ["Proteins", "Vitamins", "Minerals", "Legumes"],
    explanations: [
      "Glucose is rich in carbohydrates and soybean is rich in proteins.",
    ],
  },
  {
    id: 21,
    question:
      "A group of people, typically with vehicles or animals traveling together is called",
    answer: "Caravan",
    options: ["Claque", "Caravan", "Brood", "Cache"],
    explanations: [
      "Claque - A group of sycophantic followers.",
      "Caravan - A group of people, typically with vehicles or animals traveling together.",
      "Brood - A family of birds or other young animals produced at one hatching.",
      "Cache-A collection of items of the same type stored in a hidden or inaccessible place.",
    ],
  },
  {
    id: 22,
    question: "A series of stars is called",
    answer: "Constellation",
    options: ["Caucus", "Congregation", "Cortege", "Constellation"],
    explanations: [
      "Caucus - A conference of members of a legislative body who belong to a particular party or faction.",
      "Congregation - A group of people assembled for religious worship.",
      "Cortege - A solemn procession, especially for a funeral.",
      "Constellation - A series of stars.",
    ],
  },
  {
    id: 23,
    question:
      "Condolence is related to Loss in the same way as congratulation is related to...",
    answer: "Achievement",
    options: ["Praise", "Achievement", "Accusation", "Reward"],
    explanations: [
      "Others offer condolence in a state of loss and congratulations when one makes an achievement.",
    ],
  },
  {
    id: 24,
    question:
      "Victory is related to Happiness in the same way as Failure is related to...",
    answer: "Frustration",
    options: ["Defeat", "Anger", "Frustration", "Sadness"],
    explanations: ["Second is the result of the first."],
  },
  {
    id: 25,
    question:
      "Tobacco is related to Nerves in the same way as Alcohal is related to...",
    answer: "Liver",
    options: ["Liver", "Liquor", "Intoxication", "Head"],
    explanations: ["Consumption of first adversely affects the second."],
  },

  {
    id: 26,
    question:
      "From his house, Lokesh went 15 km to the North. Then he turned west and covered 10 km. Then he turned south and covered 5 km. Finally turning to the east, he covered 10 km. In which direction is he from his house?",
    answer: "North",
    options: ["East", "West", "North", "South"],
    explanations: ["North -> west -> South -> East = North"],
  },
  {
    id: 27,
    question:
      "A boy facing north turns 60 degree in clockwise direction and then turns 150 degree in anti-clockwise. which direction is he facing now.",
    answer: "West",
    options: ["South", "North", "East", "West"],
    explanations: ["Boy is facing West."],
  },
  {
    id: 28,
    question: "Bihar is the most populated state of India",
    answer: "False",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: ["UP is the most populated state of India."],
  },

  {
    id: 29,
    question: "Plastic is a non-biodegradable material because",
    answer: "Plastic is not an organic material",
    options: [
      "Plastic is not an organic material",
      "Microbes don't like its taste",
      "It is acidic in nature",
      "It grows naturally",
    ],
    explanations: [
      "Plastic is a non-biodegradable material because plastic is not an organic material.",
    ],
  },
  {
    id: 30,
    question: "India is a secular country because",
    answer: "Constitution is secular",
    options: [
      "India's PM is secular",
      "India's people are secular",
      "Constitution is secular",
      "It's a democratic country",
    ],
    explanations: [
      "India is a secular country because the Constitution is secular.",
    ],
  },
  {
    id: 31,
    question: "1, 16, 2, 15, 3, 14, 4, ?",
    answer: "13",
    options: ["11", "12", "13", "14"],
    explanations: [
      "Number at odd position is increased by 1 while at even is reduced by 1.",
    ],
  },
  {
    id: 32,
    question: "A O B O D O O G O O O _ _",
    answer: "KO",
    options: ["KO", "JP", "OR", "None of these"],
    explanations: [
      "Proceed the letter with the number of O's after the given letter and put O next to it.",
    ],
  },
  {
    id: 33,
    question: "Light : Darkness :: Company : ?",
    answer: "Solitude",
    options: ["Friendship", "Enmity", "Shyness", "Solitude"],
    explanations: ["The pair is antonyms of each other."],
  },
  {
    id: 34,
    question:
      "Gun is related to Bullet in the same way as Chimney is related to...",
    answer: "Smoke",
    options: ["House", "Ground", "Smoke", "Ceremics"],
    explanations: ["Second comes out of the first."],
  },
  {
    id: 35,
    question:
      "The Last alphabet of the word which comes last in the dictionary : Unease, Undone, Unheard, Unity",
    answer: "y",
    options: ["e", "y", "d", "t"],
    explanations: ["Unity comes last in dictionary."],
  },
  {
    id: 36,
    question: "Cat : Mouse",
    answer: "Bird : Worm",
    options: ["Horse : Stable", "Trap : Cheese", "Bird : Worm", "Lion : Cage"],
    explanations: ["First eat he second."],
  },
  {
    id: 37,
    question: "Cool : Cold",
    answer: "Pretty : Beautiful",
    options: [
      "Length : Width",
      "Gold : Bourne",
      "Plant : Tree",
      "Pretty : Beautiful",
    ],
    explanations: ["Second is of higher intensity than the first."],
  },
  {
    id: 38,
    question: "Find the wrong number in the series : 3, 8, 15, 24, 34, 48, 63",
    answer: "34",
    options: ["15", "24", "34", "None of these"],
    explanations: [
      "The difference between consecutive terms of the given series are respectively 5, 7, 9, 11, and 13. Clearly, 34 is a wrong number and must be replaced by (24 + 11) i.e. 35.",
    ],
  },
  {
    id: 39,
    question: "Find the odd one out.",
    answer: "PENAL",
    options: ["PENAL", "IDHNI", "RUUD", "KRTSINSA"],
    explanations: ["Only Penal is a word in the dictionary."],
  },
  {
    id: 40,
    question: "Choose the group of letters which is different from the others.",
    answer: "KMN",
    options: ["BCD", "KMN", "QRS", "GHI"],
    explanations: ["Every group has consecutive letters except KMN."],
  },
];
